import React, { useEffect, useState } from "react";
import Navbar from '../../layouts/Navbar';
import Sidebar from '../../layouts/Sidebar';
import { Link, useNavigate } from "react-router-dom";
import Footer from '../../layouts/Footer';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';

const ViewTutors = () => {
    const [tutors, setTutors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const navigate = useNavigate();

    // Fetch tutors from API
    const fetchTutors = async () => {
        try {
            setLoading(true);

             const response = await axios.get('https://pastq.eddcodesgh.com/qApi/admin/tutors/_tutors.php', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506`
            },
                withCredentials: true
            });


            if (response.data.status === 'success') {
                setTutors(response.data.tutors);
            } else {
                toast.error('Failed to fetch tutors');
            }
        } catch (error) {
            console.error('Error fetching tutors:', error);
            toast.error('Error loading tutors data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTutors();
    }, []);

    // Format status with badge
    const formatStatus = (status) => {
        let badgeClass = 'bg-secondary';
        switch(status) {
            case 'active': badgeClass = 'bg-success'; break;
            case 'pending': badgeClass = 'bg-warning'; break;
            case 'rejected': badgeClass = 'bg-danger'; break;
            case 'suspended': badgeClass = 'bg-dark'; break;
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };

    // Format verification status
    const formatVerification = (verified) => {
        return verified === '1' || verified === 1 || verified === true ? 
            <span className="badge bg-success"><i className="bi bi-check-circle me-1"></i>Verified</span> : 
            <span className="badge bg-warning"><i className="bi bi-clock me-1"></i>Pending</span>;
    };

    // Format payment status
    const formatPaymentStatus = (paymentStatus, registrationPaid) => {
        if (registrationPaid === '1' || registrationPaid === 1 || registrationPaid === true) {
            return <span className="badge bg-success">Paid</span>;
        }
        
        switch(paymentStatus) {
            case 'paid': return <span className="badge bg-success">Paid</span>;
            case 'pending': return <span className="badge bg-warning">Pending</span>;
            case 'failed': return <span className="badge bg-danger">Failed</span>;
            default: return <span className="badge bg-secondary">Not Paid</span>;
        }
    };

    // Handle delete tutor
    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this tutor?')) {
            try {
                const response = await axios.delete(`https://pastq.eddcodesgh.com/qApi/admin/tutors/_tutors.php?id=${id}`, 

                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506"
                        },
                        withCredentials: true
                    }
                );
                if (response.data.status === 'success') {
                    toast.success('Tutor deleted successfully');
                    fetchTutors(); // Refresh the list
                } else {
                    toast.error(response.data.message || 'Failed to delete tutor');
                }
            } catch (error) {
                toast.error('Error deleting tutor');
            }
        }
    };

    // Handle tutor verification
    const handleVerify = async (id, currentStatus) => {
        const newStatus = currentStatus === '1' ? '0' : '1';
        try {
            const response = await axios.put(`https://pastq.eddcodesgh.com/qApi/admin/tutors/_tutors.php`, {
                id: id,
                verified: newStatus
            }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506"
                    },
                    withCredentials: true
                });
            if (response.data.status === 'success') {
                toast.success(`Tutor ${newStatus === '1' ? 'verified' : 'unverified'} successfully`);
                fetchTutors(); // Refresh the list
            } else {
                toast.error(response.data.message || 'Failed to update verification');
            }
        } catch (error) {
            console.error('Error updating verification:', error);
            toast.error('Error updating verification');
        }
    };

    const filteredTutors = tutors.filter(item =>
        item.full_name?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.phone?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.qualification?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.subjects?.toLowerCase().includes(filterText.toLowerCase())
    );

    // DataTable columns
    const columns = [
        // {
        //     name: '#',
        //     selector: row => row.id,
        //     sortable: true,
        //     width: '70px'
        // },
        {
            name: 'Name',
            selector: row => row.full_name || 'N/A',
            sortable: true,
            cell: row => (
                <div>
                    <strong>{row.full_name}</strong>
                    <br />
                    <small className="text-muted">{row.email}</small>
                </div>
            ),
            width: '200px'
        },
        {
            name: 'Contact',
            selector: row => row.phone || 'N/A',
            sortable: true,
            width: '120px'
        },
        {
            name: 'Qualification',
            selector: row => row.qualification || 'N/A',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Expertise',
            selector: row => row.expertise || 'N/A',
            sortable: true,
            width: '150px'
        },
        {
            name: 'Subjects',
            selector: row => row.subjects || 'N/A',
            sortable: true,
            cell: row => (
                <div style={{ maxWidth: '200px' }}>
                    <small>{row.subjects}</small>
                </div>
            ),
            width: '200px'
        },
        {
            name: 'Experience',
            selector: row => `${row.experience || '0'} years`,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Rate',
            selector: row => `GHS ${row.hourly_rate || '0'}/hr`,
            sortable: true,
            width: '100px'
        },
        {
            name: 'Status',
            cell: row => formatStatus(row.status),
            sortable: true,
            width: '100px'
        },
        {
            name: 'Verified',
            cell: row => (
                <div>
                    {formatVerification(row.verified)}
                    <br />
                    <small>
                        <button 
                            className="btn btn-sm btn-outline-primary mt-1"
                            onClick={() => handleVerify(row.id, row.verified)}
                            title={row.verified === '1' ? 'Unverify' : 'Verify'}
                        >
                            <i className={`bi bi-${row.verified === '1' ? 'x' : 'check'}-circle`}></i>
                        </button>
                    </small>
                </div>
            ),
            width: '120px'
        },
        {
            name: 'Payment',
            cell: row => formatPaymentStatus(row.payment_status, row.registration_paid),
            sortable: true,
            width: '100px'
        },
        {
            name: 'Registered',
            selector: row => new Date(row.created_at).toLocaleDateString(),
            sortable: true,
            width: '120px'
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="btn-group" role="group">
                    {/* <Link 
                        className="btn btn-sm btn-primary" 
                        to={`/admin/tutors/view/${row.id}`}
                        title="View Details"
                    >
                        <i className="bi bi-eye"></i>
                    </Link> */}
                    <Link 
                        className="btn btn-sm btn-warning" 
                        to={`/admin/tutors/edit/${row.id}`}
                        title="Edit"
                    >
                        <i className="bi bi-pencil"></i>
                    </Link>
                    <button 
                        className="btn btn-sm btn-danger" 
                        onClick={() => handleDelete(row.id)}
                        title="Delete"
                    >
                        <i className="bi bi-trash"></i>
                    </button>
                </div>
            ),
            width: '150px'
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#f8f9fa',
                fontWeight: 'bold',
                fontSize: '14px',
            },
        },
        cells: {
            style: {
                fontSize: '13px',
            },
        },
    };

    const SubHeaderComponent = () => (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="input-group" style={{ width: '300px' }}>
                <span className="input-group-text">
                    <i className="bi bi-search"></i>
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search tutors..."
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                />
                {filterText && (
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => {
                            setFilterText('');
                            setResetPaginationToggle(!resetPaginationToggle);
                        }}
                    >
                        <i className="bi bi-x"></i>
                    </button>
                )}
            </div>
            <div>
                <button 
                    className="btn btn-primary"
                    onClick={fetchTutors}
                    title="Refresh"
                >
                    <i className="bi bi-arrow-clockwise"></i> Refresh
                </button>
                <Link 
                    className="btn btn-success ms-2"
                    to="/tutors/apply" target="_blank"
                >
                    <i className="bi bi-plus-circle"></i> Add Tutor
                </Link>
            </div>
        </div>
    );

    return (
        <>
            <Navbar />
            <Sidebar />
            <main id="main" className="main">
                <div className="pagetitle">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-body shadow">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h5 className="mt-3 mb-0">Tutor Management</h5>
                                        <nav>
                                            <ol className="breadcrumb mb-0">
                                                <li className="breadcrumb-item">
                                                    <Link to='/dashboard'>
                                                        <i className="bi bi-arrow-return-left"></i> Dashboard
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">Tutor List</li>
                                            </ol>
                                        </nav>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <span className="badge bg-primary me-2">
                                            Total: {tutors.length}
                                        </span>
                                        <span className="badge bg-success me-2">
                                            Verified: {tutors.filter(t => t.verified === '1').length}
                                        </span>
                                        <span className="badge bg-warning">
                                            Pending: {tutors.filter(t => t.verified !== '1').length}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">All Tutors</h5>
                                    
                                    <SubHeaderComponent />
                                    
                                    <DataTable
                                        columns={columns}
                                        data={filteredTutors}
                                        progressPending={loading}
                                        pagination
                                        paginationResetDefaultPage={resetPaginationToggle}
                                        highlightOnHover
                                        responsive
                                        customStyles={customStyles}
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                        noDataComponent={
                                            <div className="text-center py-5">
                                                <i className="bi bi-people display-1 text-muted"></i>
                                                <h5 className="mt-3">No tutors found</h5>
                                                <p className="text-muted">
                                                    {filterText ? 'Try a different search term' : 'No tutors registered yet'}
                                                </p>
                                            </div>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default ViewTutors;